import { useEffect, useState } from "react";
import ThemeProvider from "react-bootstrap/ThemeProvider";
import { AuthProvider } from "@hooks/contexts/auth-context";
import { BrowserRouter, useLocation } from "react-router-dom";
import { ModalProvider } from "@hooks/contexts/modal-context";
import { SidebarCollapseProvider } from "@hooks/contexts/SidebarCollapseContext";
import { TopbarCollapseProvider } from "@hooks/contexts/TopbarCollapseContext";
import { ToastContainer } from "react-toastify";
import AppRoutes from "routes";
import { config } from "config";

function ToastContainerWrapper() {
  // --- Fix Toastfy Message --- //
  const location = useLocation();
  const [key, setKey] = useState(0);
  useEffect(() => {
    setKey((prev) => prev + 1);
  }, [location.pathname]);

  return <ToastContainer key={key} />;
}

function App() {
  document.title = config.appName;

  return (
    <ThemeProvider
      breakpoints={["xxxl", "xxl", "xl", "lg", "md", "sm", "xs", "xxs"]}
      minBreakpoint="xxs"
    >
      <BrowserRouter>
        <AuthProvider>
          <ModalProvider>
            <TopbarCollapseProvider>
              <SidebarCollapseProvider>
                <AppRoutes />
              </SidebarCollapseProvider>
            </TopbarCollapseProvider>
          </ModalProvider>
        </AuthProvider>
        <ToastContainerWrapper />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
